import { CoreSignupInfoService } from "../core/signup-info-service";


export class LocalSignupInfoService extends CoreSignupInfoService {
    getBaseUrl = () => `https://localhost:57326/api/new-vendors-portal`;
}
